// extracted by LIB_CSS_EXTRACT_LOADER
import "./popover_module.css"
export default {"anchor":"anchor-cDsUov","positioner":"positioner-S1_qdm","popup":"popup-q3qL0G"};